module.exports = __webpack_public_path__ + "static/media/charlesMarion19.97367c51.png";